import { useEffect, useRef, useState } from "react";
import { REELS } from "../data/reels";

const ReelCard = ({ id, index }) => {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          setVisible(true);
          io.disconnect();
        }
      },
      { threshold: 0.1, rootMargin: "200px" }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      data-testid={`reel-${id}`}
      className="phone-frame shrink-0 w-[78vw] max-w-[260px] sm:w-[240px] snap-center"
      style={{ transform: `rotate(${(index % 3) - 1}deg)` }}
    >
      <div className="phone-screen">
        {visible ? (
          <iframe
            src={`https://www.instagram.com/reel/${id}/embed/`}
            title={`reel-${id}`}
            className="absolute inset-0 w-full h-full"
            frameBorder="0"
            scrolling="no"
            allow="encrypted-media"
            loading="lazy"
          />
        ) : (
          <div className="absolute inset-0 bg-gradient-to-br from-[#2A0A70] to-[#0A0320] flex items-center justify-center">
            <span className="mono text-[10px] text-white/40">loading…</span>
          </div>
        )}
      </div>
    </div>
  );
};

export const VideosSection = () => {
  return (
    <section id="videos" className="relative py-16 sm:py-24 bg-[color:var(--mr-purple-dark)] text-white overflow-hidden">
      <div className="absolute inset-0 opacity-40 pointer-events-none" style={{
        backgroundImage: "radial-gradient(circle at 20% 10%, rgba(240,20,138,0.3), transparent 40%), radial-gradient(circle at 90% 80%, rgba(64,20,204,0.6), transparent 50%)"
      }} />
      <div className="relative max-w-6xl mx-auto px-5">
        <div className="mb-8 sm:mb-14 flex items-baseline gap-3 flex-wrap">
          <span className="mono text-xs sm:text-sm text-white/60">[</span>
          <h3 className="display text-[32px] sm:text-[48px] lg:text-[64px] leading-[0.95]">
            algunos videos<br className="sm:hidden" /> que hemos creado
          </h3>
          <span className="mono text-xs sm:text-sm text-white/60">]</span>
        </div>

        <div
          className="flex gap-5 sm:gap-7 overflow-x-auto pb-6 no-scrollbar snap-x snap-mandatory -mx-5 px-5"
          style={{ scrollPadding: "0 20px" }}
          data-testid="reels-carousel"
        >
          {REELS.map((r, i) => (
            <ReelCard key={r.id} id={r.id} index={i} />
          ))}
        </div>

        <div className="mono text-[10px] sm:text-xs tracking-widest uppercase text-white/50 mt-8 text-center">
          ← desliza para ver más →
        </div>
      </div>
    </section>
  );
};
